
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class EmailPartTypeSwitcher extends Vue {
  @Prop() type!: string;
  @Prop() prefix!: string;
  @Prop() content!: string;
  @Prop() imageSrc!: string;
  @Prop() imageAlt!: string;
  @Prop() modal!: boolean;
  @Prop() complete!: boolean;
  @Prop() incorrect!: boolean;
  @Prop() arrowLeft!: boolean;
}
